<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <!--计划单据编号-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.MSVNumber')" prop="msvNo">
                  <el-input v-model="queryCondition.msvNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <!-- 拜访年份 -->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Year')" prop="Year">
                  <el-date-picker v-model="queryCondition.year" type="year" clearable value-format="yyyy" placeholder="选择年" style="width:100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!--供应商类型-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Type')" prop="type">
                  <el-select v-model="queryCondition.type" clearable @change="typeChange" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in typeList" :label="item.chineseValue" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--类型-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Category')" prop="category">
                  <el-select v-model="queryCondition.category" clearable @change="CategoryChange" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in categoryList" :label="item.NAME" :value="item.NAME"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <!--供应商工厂-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.SupplierFacility')" prop="tmSupplierId">
                    <el-input v-model="queryCondition.supplierName" clearable @clear="clearSupplierName" style="width:100%">
                      <el-button slot="append" icon="el-icon-search" @click="searchSupplier()"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!--报告状态-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.ReportStatus')" prop="status">
                    <el-select v-model="queryCondition.status" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in MSVStatusList" :label="item.chineseValue" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--创建时间-->
                <el-col :span="6">
                  <el-form-item label="创建时间(从)" prop="createQueryBeginData">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createQueryBeginData" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    <!-- <el-date-picker ref="dataArr2Ref" v-model="queryCondition.dataArr2" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建时间(至)" prop="createQueryEndData">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createQueryEndData" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    <!-- <el-date-picker ref="dataArr2Ref" v-model="queryCondition.dataArr2" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <!--创建人-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.CreateUser')">
                    <el-input v-model="queryCondition.creater" clearable style="width:100%">
                      <el-button slot="append" icon="el-icon-search" @click="searchCreateBy()"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!--拜访日期-->
                <el-col :span="6">
                  <el-form-item label="拜访日期(从)" prop="visitBeginDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.visitBeginDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    <!-- <el-date-picker ref="dataArrRef" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="拜访日期(至)" prop="visitEndDate">
                    <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.visitEndDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    <!-- <el-date-picker ref="dataArrRef" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <el-table :data="tableList" ref="tableList" border max-height='450' highlight-current-row>
      <el-table-column type="index" fixed min-width="50" :label="$t('visitPlan.SerialNumber')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="msvNo" fixed label="MSV 单据编号" min-width='130'>
        <template slot-scope="scope">
          <div class="a-link" @click="toReportDetail(scope.row.ttMsvReportId)">{{scope.row.msvNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="year" :label="$t('visitPlan.Year')" min-width='80'></el-table-column>
      <el-table-column show-overflow-tooltip prop="type" :label="$t('visitPlan.Type')" min-width='120'></el-table-column>
      <el-table-column show-overflow-tooltip prop="category" :label="$t('visitPlan.Category')" min-width='120'></el-table-column>
      <el-table-column show-overflow-tooltip prop="plantName" label="工厂" min-width='200'></el-table-column>
      <el-table-column show-overflow-tooltip prop="statusI18n" label="报告状态" min-width='120'></el-table-column>
      <el-table-column show-overflow-tooltip prop="visitBeginDate" label="拜访日期" min-width='150'>
        <template slot-scope="scope">{{scope.row.visitBeginDate | dateFormatFilter("YYYY-MM-DD")}}——{{scope.row.visitEndDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="mgtRecap" label="拜访总结" min-width='120'></el-table-column>
      <el-table-column show-overflow-tooltip prop="msvResultI18n" label="拜访反馈结果" min-width='120'></el-table-column>
      <el-table-column show-overflow-tooltip prop="creater" min-width='140' :label="$t('visitPlan.CreateUser')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" :label="$t('visitPlan.CreateDate')" min-width='120'>
        <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier :multipleSelectionFlag="true" v-if="DestroyIncomeStatistics == true" ref="supplierSelRef" :categoryLevel1Name=categoryLevel1Name :categoryLevel2Name=categoryLevel2Name @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
    <el-dialog :visible.sync="showUserDialog" width="80%">
      <PickupUser @input="selectUserData"></PickupUser>
    </el-dialog>
  </div>
</template>
<script>
import { getVisitReportListSP, getVisitReportList, getCategoryValue } from "@/api/visitPlan.js";
import PickupUser from "@/components/page/visitPlan/choiceUser";
import { applyService } from "../../../api/quotation-apply/quotation-apply";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils";
import SelSupplier from "@/components/page/visitPlan/supplierFactory";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import store from '@/store/index';
import paginationMixin from '@/mixins/pagitionMixin';
export default {
  name: "",
  mixins: [paginationMixin],
  components: { PickupUser, SelSupplier },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      categoryLevel1Name: '',
      categoryLevel2Name: '',
      totalCount: 0,
      tableList: [],
      typeList: [],
      MSVStatusList: [],
      categoryList: [],
      queryCondition: {
        msvNo: '',
        status: '',
        pageSize: 15,
        pageNum: 1,
        year: '',
        supplierCode: '',
        category: '',
        type: '',
        creater: '',
        tmSupplierIds: [],
        supplierName: '',
        createQueryBeginData: "",
        createQueryEndData: "",
        visitBeginDate: "",
        visitEndDate: "",
        // dataArr: [],
        // dataArr2: []
      },
      statusList: [],
      quotationStatusList: [],
      quotationTypeList: [],
      applyTypeList: [],
      radioVal: null,
      selectRow: null,
      showUserDialog: false,
      showSelSupplierDialog: false,
      categoryLevel1Name: '',
      categoryLevel2Name: '',
      DestroyIncomeStatistics: false,
      isHGS: false,
    };
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.queryCondition = to.meta.reqData;
      vm.dataArr = to.meta.reqData.dataArr;
      vm.isHGS = commonFun.havePermission("IS_HGS");
      vm.queryData(1);
    })
  },
  created() {
    //this.queryData(1);
    this.getInputChoiceValues();
    this.isHGS = commonFun.havePermission("IS_HGS");
  },
  methods: {
    queryData(val) {
      let that = this
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      // let dataArrValue = that.queryCondition.dataArr;
      // let dataArr2Value = that.queryCondition.dataArr2;
      // this.queryCondition.visitBeginDate = !!dataArrValue ? this.$options.filters["dateFormatFilter"](dataArrValue[0]) : "",
      //   this.queryCondition.visitEndDate = !!dataArrValue ? this.$options.filters["dateFormatFilter"](dataArrValue[1]) : "",
      //   this.queryCondition.createQueryBeginData = !!dataArr2Value ? this.$options.filters["dateFormatFilter"](dataArr2Value[0]) : "",
      //   this.queryCondition.createQueryEndData = !!dataArr2Value ? this.$options.filters["dateFormatFilter"](dataArr2Value[1]) : "",
      //   console.log(this.queryCondition)
      getVisitReportListSP(this.queryCondition).then(res => {
        that.tableList = res.resultData;
        that.totalCount = res.totalCount;
      });
    },
    toReportDetail(id) {
      if (this.actionCheck.actionCheck('Msv-reportQueryDetail') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      let resolve = this.$router.resolve({
        path: `/visitReportSp-detail`,
        query: { ttMsvReportId: id }
      });
      window.open(resolve.href, "_blank");
    },
    typeChange(val) {
      this.categoryLevel1Name = val
      this.categoryLevel2Name = ''
      this.queryCondition.supplierCode = ''
      this.queryCondition.tmSupplierIds = []
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
      if (val == 'Food') {
        this.getCategory(val)
      } else {
        this.categoryList = []
        this.queryCondition.category = ''
      }
    },
    CategoryChange(val) {
      this.categoryLevel2Name = val
      this.queryCondition.supplierCode = ''
      this.queryCondition.tmSupplierIds = []
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
    },
    //动态获取Category下拉框的值
    getCategory(value) {
      let that = this;
      let data = {
        categoryLevel1Name: value
      }
      getCategoryValue(data).then(res => {
        this.categoryList = res.data
      });
    },
    //搜索供应商工厂
    searchSupplier() {
      this.$nextTick(() => {
        this.DestroyIncomeStatistics = true;
      });
      this.showSelSupplierDialog = true
    },
    searchCreateBy(value) {
      this.showUserDialog = true
    },
    selectUserData(name, id) {
      this.queryCondition.creater = name
      this.showUserDialog = false
    },
    selectSupplierMethod: function (supList) {
      let that = this
      that.queryCondition.tmSupplierIds = [];
      that.queryCondition.supplierCode = '';
      supList.forEach((item) => {
        that.queryCondition.tmSupplierIds.push(item.tmSupplierId);
        that.queryCondition.supplierCode = that.queryCondition.supplierCode + item.supplierCode + ',';
      });
      that.queryCondition.supplierCode = supList.map(sup => sup.supplierCode).join(',');
      that.queryCondition.supplierName = supList.map(sup => sup.supplierName).join(',');
      that.showSelSupplierDialog = false;
    },
    //查询条件重置方法
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        msvNo: '',
        status: '',
        pageSize: 15,
        pageNum: 1,
        year: '',
        supplierCode: '',
        category: '',
        type: '',
        creater: '',
        tmSupplierIds: [],
        supplierName: '',
        createQueryBeginData: "",
        createQueryEndData: "",
        visitBeginDate: "",
        visitEndDate: "",
        // dataArr: [],
        // dataArr2: []
      }
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
      this.tmSupplierId = [];
      // this.queryCondition.dataArr = [];
      // if (!!this.$refs.dataArrRef.userInput) {
      //   this.$refs.dataArrRef.userInput = ["", ""];
      // }
      // this.queryCondition.dataArr2 = [];
      // if (!!this.$refs.dataArr2Ref.userInput) {
      //   this.$refs.dataArr2Ref.userInput = ["", ""];
      // }

    },
    querySearch(queryString, cb) {
      var restaurants = this.categoryList;
      restaurants = restaurants.map(obj => {
        return {
          ...obj,
          value: obj.chineseValue
        }
      })
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    addNewApply: function (applyId) {
      this.$router.replace({
        name: "applyDetail",
        params: { applyId: applyId, source: "apply" }
      });
    },

    openQuotationApplyDetail: function (row) {
      this.$router.replace({
        name: "applyDetail",
        params: {
          applyId: row.ttQuotationApplyId,
          source: "apply",
          applyType: row.applyType
        }
      });
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    clearSupplierName() {
      this.queryCondition.supplierCode = "";
      this.queryCondition.tmSupplierIds = []
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    getInputChoiceValues() {
      let that = this
      let mapObj = {};
      mapObj["TT_MSV:TYPE"] = "TT_MSV:TYPE";
      mapObj["TT_MSV:SP_REPORTSTATUS"] = "TT_MSV:SP_REPORTSTATUS";
      mapObj["TT_MSV:CATEGORYTYPE"] = "TT_MSV:CATEGORYTYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        let typeList = res["TT_MSV:TYPE"];
        if (that.isHGS) {
          for (let j = 0, len = typeList.length; j < len; j++) {
            if (typeList[j].code == "Package") {
              that.typeList = [typeList[j]];
            }
          }
        } else {
          that.typeList = typeList
        }

        that.MSVStatusList = res["TT_MSV:SP_REPORTSTATUS"];
        // this.categoryList = res["TT_MSV:CATEGORYTYPE"];
      });
    },
    openSoucingInfo: function (sourcingNo) {
      this.$router.push({
        path: "/sourcing-detail",
        query: { sourcingNo: sourcingNo }
      });
    }
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.el-table {
  margin-top: 10px;
}
</style>
<style lang="scss">
.visitReportSp {
  .el-form-item__content {
    width: 220px;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 220px;
  }
}
</style>
